// extracted by mini-css-extract-plugin
module.exports =  {"link":"practiceToolbar__link","title":"practiceToolbar__title","wrapper":"practiceToolbar__wrapper","mb":"practiceToolbar__mb"};